export const GTE = "\u2265";

export const LTE = "\u2264";

export const LEFTWARDS_ARROW = "\u2190";

export const RIGHTWARDS_ARROW = "\u2192";
